"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
document.addEventListener("DOMContentLoaded", function () {
    if (__spreadArrays(Array.from(document.body.classList)).includes("basiljs")) {
        var elements_1 = document.querySelectorAll(".featured-project");
        if (elements_1.length !== 0) {
            var idx_1 = 0;
            elements_1[0].style.display = "inline";
            setInterval(function () {
                elements_1[idx_1 % elements_1.length].style.display = "inline";
                elements_1.forEach(function (ele, i) {
                    if (i !== idx_1 % elements_1.length) {
                        ele.style.display = "none";
                    }
                });
                idx_1++;
            }, 2000);
        }
    }
});
